/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { propDeprecationWarning } from '@atlaskit/ds-lib/deprecation-warning';
import noop from '@atlaskit/ds-lib/noop';
import { N20A } from '@atlaskit/theme/colors';
import SkeletonShimmer from '../internal/components/skeleton-shimmer';
var skeletonStyles = css({
  paddingBlock: "var(--ds-space-0, 0px)",
  paddingInline: "var(--ds-space-200, 16px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '::after': {
    display: 'block',
    width: '30%',
    height: "var(--ds-space-100, 8px)",
    backgroundColor: "var(--ds-skeleton, ".concat(N20A, ")"),
    borderRadius: 100,
    content: '""'
  }
});
var defaultWidthStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '::after': {
    width: '30%'
  }
});
var customWidthStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '::after': {
    width: 'var(--width)'
  }
});

/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */
var SkeletonHeadingItem = function SkeletonHeadingItem(_ref) {
  var _ref$isShimmering = _ref.isShimmering,
    isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering,
    testId = _ref.testId,
    width = _ref.width,
    _ref$cssFn = _ref.cssFn,
    cssFn = _ref$cssFn === void 0 ? noop : _ref$cssFn;
  propDeprecationWarning("@atlaskit/menu" || '', 'cssFn', cssFn !== noop, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
  );

  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  var UNSAFE_overrides = css(cssFn(undefined));
  return jsx(SkeletonShimmer, {
    isShimmering: isShimmering
  }, function (_ref2) {
    var className = _ref2.className;
    return jsx("div", {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      className: className
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      ,
      style: {
        '--width': width
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      },
      css: [skeletonStyles, width ? customWidthStyles : defaultWidthStyles,
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
      UNSAFE_overrides],
      "data-ds--menu--skeleton-heading-item": true,
      "data-testid": testId
    });
  });
};
export default SkeletonHeadingItem;